<template>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Выберите автоматы</h2>
      </div>
      <div class="modal-body p-0">
        <filtered-data
          ref="data"
          v-model="data"
          endpoint="notification_settings/machines"
          endpointMethod="post"
          :exclude="checked"
          :filtersValue="filtersValue"
          :loading.sync="loading"
          :hasMore.sync="hasMore"
        ></filtered-data>
        <div class="row">
          <div class="col-8 pr-0">
            <template v-if="data && data.data">
              <data-table
                :height="600"
                :data="data.data"
                :hasMore="hasMore"
                :loading="loading"
                @load-more="$refs.data.loadMore"
                @selection-change="(selection) => {this.list = selection}"
              >
                <el-table-column type="selection"/>
                <table-column-serial-number/>
                <el-table-column prop="address" label="Адрес"/>
                <el-table-column prop="technician" label="Техник">
                  <template slot-scope="{row}">{{row.technician | fullName }}</template>
                </el-table-column>
                <el-table-column prop="operator" label="Оператор">
                  <template slot-scope="{row}">{{row.operator | fullName }}</template>
                </el-table-column>
                <el-table-column prop="manager" label="Менеджер">
                  <template slot-scope="{row}">{{row.manager | fullName }}</template>
                </el-table-column>
                <el-table-column prop="region.name" label="Организация"/>
              </data-table>
            </template>
          </div>
          <div class="col-4 pl-0 border-left">
            <div style="overflow-y: scroll; height: 600px;">
              <filters
                v-if="data.filters"
                :filters="data.filters"
                endpoint="notification_settings/machines"
                v-model="filtersValue"
                endpointMethod="post"
              ></filters>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="save">Добавить</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      checked: {},
    },
    data () {
      return {
        filtersValue: {},
        data: {},
        loading: false,
        hasMore: true,
        list: [],
      }
    },
    methods: {
      save () {
        const list = this.list.map((item) => item.id)
        this.$emit('hide', this.data.data.filter((value) => {
          return (list.indexOf(value.id) !== -1) && (this.checked.indexOf(value.id) === -1)
        }))
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/machines-modal.vue